var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col",attrs:{"id":"app"}},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage!== 'Pay'),expression:"currentPage!== 'Pay'"}]}),_c('div',{staticClass:"flex-full"},[_c('router-view',{staticClass:"flex-full router-view"})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }